import React from "react";
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/DownloadDrop.scss";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const DownloadDropDown = (props) => {
    var _a;
    const device = (_a = DeviceContext()) === null || _a === void 0 ? void 0 : _a.isDesktop;
    return (React.createElement("div", { className: `${props.parentClassName}` },
        React.createElement("div", { className: `download-drop p-2 ${device ? " position-absolute end-0" : "w-100 position-static mt-0"}` },
            React.createElement("div", { className: `download-drop-body ${!device && "justify-content-center"}` },
                React.createElement("ul", null,
                    React.createElement("li", { className: "download-drop-bodylist p-1" }, props.bodyList.map((el, idx) => {
                        return (React.createElement("div", { key: idx, className: "my-2" },
                            React.createElement("label", null,
                                React.createElement("p", { className: "list-title pt-2", onClick: () => {
                                        (el === null || el === void 0 ? void 0 : el.onClick) && el.onClick();
                                    } }, el.title))));
                    })))))));
};
export default DownloadDropDown;
